<template>
    <div>
        <b-card no-body>
            <b-card-header>
                <h5>
                    MENSAGEM -
                    <b-badge variant="warning">{{operacao}}</b-badge>
                    <app-btn-voltar class="float-right ml-2" rota="Mensagens" variant="secondary"></app-btn-voltar>
                    <ler-nao-ler
                        :mensagem="mensagemBase"
                        @obterMensagensAtualizadas="$emit('obterMensagensAtualizadas')"
                        @obterMensagemAtualizada="obterMensagem()"
                    ></ler-nao-ler>
                    <enviar
                        v-if="mensagem"
                        :mensagem="mensagem"
                        @obterMensagensAtualizadas="$emit('obterMensagensAtualizadas')"
                    ></enviar>
                    <salvar
                        v-if="mensagem"
                        :mensagem="mensagem"
                        @obterMensagensAtualizadas="$emit('obterMensagensAtualizadas')"
                    ></salvar>
                    <selecionar-destinatarios
                        v-if="mensagem"
                        :mensagem="mensagem"
						:opcaoSel="opcaoSel"
						@atualizarOpcaoSel="opcaoSel = $event"
                        @atualizarDestinatarios="destinatarios = $event"
                    ></selecionar-destinatarios>
                </h5>
            </b-card-header>
            <b-card-body>
                <cabecalho :mensagem="mensagemBase" v-if="status == 1"></cabecalho>
                <b-row v-if="mostrarDestinatarios">
                    <b-col sm="12">
                        <b-form-group>
                            <label>Destinatários</label>
                            <div class="form-control">
                                <strong>{{destinatariosTexto}}</strong>
                            </div>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col sm="12">
                        <b-form-group>
                            <label>Assunto</label>
                            <b-form-input
                                type="text"
                                v-model="assunto"
                                :disabled="desabilitarEdicao"
                            ></b-form-input>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col sm="12">
                        <b-form-group>
                            <label>Mensagem</label>
                            <ckeditor
                                :editor="editor"
                                v-model="conteudo"
                                :config="editorConfig"
                                :disabled="desabilitarEdicao"
                            ></ckeditor>
                        </b-form-group>
                    </b-col>
                </b-row>
            </b-card-body>
        </b-card>
        <!-- {{ mensagem }} -->
    </div>
</template>

<script>
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
import '@ckeditor/ckeditor5-build-classic/build/translations/pt-br'
import SelecionarDestinatarios from './SelecionarDestinatarios'
import Salvar from './Salvar'
import MensagensServicos from './MensagensServicos'
import Enviar from './Enviar'
import Cabecalho from './Cabecalho'
import LerNaoLer from './LerNaoLer'

export default {
	components: {
		SelecionarDestinatarios,
		Salvar,
		Enviar,
		Cabecalho,
		LerNaoLer
	},

	data() {
		return {
			operacao: 'NOVA',
			mensagemId: '',
			assunto: '',
			conteudo: '',
			status: -1,
			mensagemBase: {},
			editor: ClassicEditor,
			editorConfig: {
				language: 'pt-br',
				toolbar: [
					'bold',
					'italic',
					'link',
					'|',
					'bulletedList',
					'numberedList',
					'blockQuote',
					'|',
					'insertTable',
					'|',
					'mediaEmbed',
					'|',
					'undo',
					'redo'
				]
			},
			destinatarios: [],
			opcaoSel: 0
		}
	},

	methods: {
		obterMensagem() {
			this.$store.dispatch('addRequest')
			MensagensServicos.obterPorId(this.$route.params.mensagemId).then(
				response => {
					if (response) {
						if (response.success) {
							this.processarMensagem(response.data)
						} else {
							this.$toast.error(
								'Erro ao obter a Mensagem',
								'ERROR',
								this.$toastConfig.error
							)
						}
					}
					this.$store.dispatch('removeRequest')
				}
			)
		},

		processarMensagem(data) {
			this.mensagemId = data.mensagemId
			this.assunto = data.assunto
			this.conteudo = data.conteudo
			this.destinatarios = data.destinatarios
			this.status = data.status
			this.statusDescr = data.statusDescr
			this.mensagemBase = Object.assign({}, data)
		}
	},

	created() {
		if (this.$route.name == 'Mensagens_Detalhar') {
			this.obterMensagem()
			this.operacao = 'DETALHAR'
		} else {
			this.status = 0
		}
	},

	computed: {
		destinatariosTexto() {
			if (!this.destinatarios || this.destinatarios.length == 0)
				return 'TODOS OS FORNECEDORES'
			return this.destinatarios
				.map(item => {
					return item.razaoSocial
				})
				.join(' | ')
		},

		mensagem() {
			return {
				mensagemId: this.mensagemId,
				assunto: this.assunto,
				conteudo: this.conteudo,
				destinatarios: this.destinatarios,
				status: this.status
			}
		},

		mostrarDestinatarios() {
			let retorno =
				this.$store.getters.fornecedor.fornecedorId === null &&
				!this.mensagemBase.externa
			return retorno
		},

		desabilitarEdicao() {
			return this.status == 1
		}
	},

	watch: {
		$route(to) {
			if (to.name === 'Mensagens_Detalhar') {
				this.obterMensagem()
				this.operacao = 'DETALHAR'
			}
		}
	}
}
</script>
